<script>
	import List from './List.svelte';
	import Edit from './Edit.svelte';
	import { tick } from 'svelte';

	export let items = [];
	let active = 'list';
	let editId = {};
	const handleClick = (tabValue) => () => {
		active = tabValue;
		editId = null;
	};
	const editItem = async (e) => {
		editId = e.detail;
		active = null;
		await tick();
		if (e.detail != null) active = 'edit';
	};
	const deleteItem = (e) => {
		console.log('delete', e.detail);
		active = 'list';
	};
</script>

{#if active == 'list'}
	<div class="box">
		<svelte:component this={List} on:editItem={editItem} on:deleteItem={deleteItem} />
	</div>
{:else}
	<header>
		<h1>Configs</h1>
	</header>
	<div class="box">
		<svelte:component this={Edit} on:back={handleClick('list')} data={editId} />
	</div>
{/if}
